import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Actions } from '@ngrx/effects'

import { SubscriptionLinkedSubscriptions } from './subscription-linked-subscriptions'
import * as fromSubscriptionLinkedSubscriptions from './subscription-linked-subscriptions.reducer'
import { SubscriptionLinkedSubscriptionsService } from './subscription-linked-subscriptions.service'
import { subscriptionLinkedSubscriptionsActions } from './subscription-linked-subscriptions.actions'
import { AppState } from 'src/app/core/core.state'
import { Store } from '@ngrx/store'

@Injectable()
export class SubscriptionLinkedSubscriptionsEffects extends ResourceEffects<SubscriptionLinkedSubscriptions> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public subscriptionLinkedSubscriptionsService: SubscriptionLinkedSubscriptionsService
  ) {
    super(
      fromSubscriptionLinkedSubscriptions.FEATURE_NAME,
      subscriptionLinkedSubscriptionsService,
      subscriptionLinkedSubscriptionsActions,
      actions$
    )
  }
}
